import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Platform from "@/pages/Platform";
import UseCases from "@/pages/UseCases";
import CaseStudies from "@/pages/CaseStudies";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
// Solution Sub-pages
import FinancialDataIntelligence from "@/pages/solutions/FinancialDataIntelligence";
import OpsIntelligenceSuite from "@/pages/solutions/OpsIntelligenceSuite";
import AgenticCoworkers from "@/pages/solutions/AgenticCoworkers";
import FinancialIntelligenceAssistant from "@/pages/solutions/FinancialIntelligenceAssistant";
import Aureon from "@/pages/solutions/Aureon";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/financial-data-intelligence" element={<FinancialDataIntelligence />} />
          <Route path="/solutions/ops-intelligence-suite" element={<OpsIntelligenceSuite />} />
          {/* Redirect old route */}
          <Route path="/solutions/agentic-operational-workflows" element={<OpsIntelligenceSuite />} />
          <Route path="/solutions/agentic-coworkers" element={<AgenticCoworkers />} />
          <Route path="/solutions/financial-intelligence-assistant" element={<FinancialIntelligenceAssistant />} />
          {/* Redirect old route */}
          <Route path="/solutions/personal-financial-assistant" element={<FinancialIntelligenceAssistant />} />
          <Route path="/solutions/aureon" element={<Aureon />} />
          <Route path="/platform" element={<Platform />} />
          {/* Redirect old technology route to platform */}
          <Route path="/technology" element={<Platform />} />
          <Route path="/use-cases" element={<UseCases />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/about" element={<About />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
